import {getCentralCss, getColorCss, getFavIcon, getHomeScreenIcon, getViewCss, getViewJs, getCentralJs} from './appConfig/customizationConfig';
const DEFAULT_COLOR_CSS = 'lib/app-colors.css';
import {loadCSS, loadScript}  from './scriptLoader';
import * as angular from 'angular';
import {getBackendSystem} from "./appConfig/appConfigForward";
const injector = angular.injector(['ng']);
const $http: ng.IHttpService = injector.get('$http');
const $q: ng.IQService = injector.get('$q');


function _bootstrapConf() {
    let vid = getVidFromLocationBar();
    if (!vid && window.location.pathname.indexOf('openurl') !== -1 && window.location.href.indexOf('&amp;vid=') !== -1 ) {
        let newLocation = window.location.href.replace(/&amp;/g, '&');
        window.location.assign(newLocation);        
    }
    
    // For google SEO in order to identify short fulldisplay url
    if (!vid && window.location.pathname.indexOf('fulldisplay') !== -1) {
        vid = getFulldisplayVidParameterFromURL();
    }

    if (!vid && window.location.pathname.indexOf('delivery') !== -1) {
        vid = getDeliveryVidParameterFromURL();
    }

    const url = new URL(window.location.href);
    const offset = url.searchParams.get('offset');
    if (offset && offset !== '0') {
        // Disallow deep linking to non-zero offset in the search results
        url.searchParams.set('offset', '0');
        window.history.replaceState({}, '', url.toString());
    }

    let defaultVidUrl=getDefaultVidUrl(window.location.hostname);
    let promise= $q((resolve, reject)=>{ 
        if (!vid){
            getConfigData(defaultVidUrl).then((response:{data:PrimoResponse.ISearchResponse}) => {
                resolve(response.data.vid);
            });
        }else{          
            resolve(vid);
        }
        
    });
    return promise.then((viddata: PrimoResponse.ISearchResponse) => {
        vid = viddata;
        let url = getConfigUrl(vid); 
        if(vid && url) {
            window.appPerformance.timeStamps['before configuration api']= Date.now();
            let promise= $q((resolve, reject)=>{
                window.resolveConfigurationPromise= resolve; //this is so that the config_{vid}.js script can resolve the promise and we don't have to wait for configuration rest API
                if (!window.appConfig || Object.keys(window.appConfig).length ==0){
                    getConfigData(url).then((response:{data:AppConfig}) => {
                        resolve(response.data); 
                    });
                }
                else{
                    resolve(window.appConfig);
                }
            });
            return promise.then((data: AppConfig) => {
                window.appConfig = data;
                window.appConfig.vid = vid;
                window.appPerformance.timeStamps['after configuration api']= Date.now();
            })
                .then(()=> {
                    if(window.location.search.indexOf('noCustomization=true')>-1) {
                        return loadDefaultColorsCss();
                    }
                    else {
                        return customizeApplication();
                    }
                });
        }
        return undefined;
    });



}

let bootstrapPromise = _bootstrapConf();

export function bootstrapConfiguration() {
    return bootstrapPromise;
}


function makeRequest(url) {
    return $http.get(url);
}


function getDeliveryVidParameterFromURL() {
    
    if ( isNaN(Number( window.location.pathname.split('/')[3]))) {
        return (window.location.pathname) ? window.location.pathname.split('/')[3] : '';
   }
}

function getDefaultVidUrl(url) {

    
     let restUrlPrimoExplore = '/primo_library/libweb/webservices/rest/v1/configuration/';
    let restUrlSuprima = '/primaws/rest/pub/defaultvid/';
    let restUrl = getBackendSystem() === 'suprima'? restUrlSuprima : restUrlPrimoExplore;
    return window.location.protocol + '//' + window.location.host + restUrl + url;
}

export function customizeApplication() {
    let p1 = loadCustomJs();
    let p2 = addCustomizedElements();
    return $q.all([p1,p2]).then(()=>p1);
}

function loadJs(jsFile) {
    let deferred = $q((resolve)=> {
        if(jsFile) {
            loadScript(jsFile).then(
                ()=> resolve(true),
                ()=> resolve(false)
            );
        }
        else {
            resolve(false);
        }


    });
return deferred;

}

function loadCustomJs() {
    let centralJs = getCentralJs();
    let p1 =  loadJs(centralJs);
    let viewJs = getViewJs();
    let p2 = loadJs(viewJs);
    return $q.all([p1,p2]);
}

function getConfigData(url) {
    return makeRequest(url);
}

export function loadDefaultColorsCss() {
    return loadCSS(DEFAULT_COLOR_CSS);

}

function addCustomizedElements(){
    try {
        let colorCss = getColorCss();
        let centralCss = getCentralCss();
        let viewCss = getViewCss();
        let promises = [];

        if(colorCss) {
            promises.push(loadCSS(colorCss));
        }
        else {
            promises.push(loadDefaultColorsCss());
        }

        if(centralCss) {
            promises.push(loadCSS(centralCss));
        }
        if(viewCss) {
            promises.push(loadCSS(viewCss));
        }

        let favIcon = getFavIcon();
        if(favIcon) {
            let viewCustomerFavIcon  = <HTMLLinkElement>document.getElementById('viewCustomerFavIcon');
            viewCustomerFavIcon.href  = favIcon;
        }
        
        let homeScreenIcon = getHomeScreenIcon();
        if (homeScreenIcon) {
            let viewHomeScreenCustomerIconAndroid = <HTMLLinkElement>document.getElementById('viewHomeScreenCustomerIconAndroid');
            viewHomeScreenCustomerIconAndroid.href = homeScreenIcon;    
            let viewHomeScreenCustomerIconIos = <HTMLLinkElement>document.getElementById('viewHomeScreenCustomerIconIos');
            viewHomeScreenCustomerIconIos.href = homeScreenIcon;
        }
        
        let canonicalFullDisplayUrl = getCanonicalFullDisplayUrl();
        if (canonicalFullDisplayUrl) {
            let canonicalFullDisplay = <HTMLLinkElement>document.getElementById('canonicalFullDisplay');
            canonicalFullDisplay.href = canonicalFullDisplayUrl;
        }

        return $q.all(promises);


    }catch(e){
        //do nothing in case there is no view...
    }
    return undefined;

}


function getConfigUrl(vid) {
    let restUrlPrimoExplore = '/primo_library/libweb/webservices/rest/v1/configuration/';
    let restUrlSuprima = '/primaws/rest/pub/configuration/vid/';
    let restUrl = getBackendSystem() === 'suprima'? restUrlSuprima : restUrlPrimoExplore;
    return window.location.protocol + '//' + window.location.host + restUrl + vid;
}

function getParameterByName(name, searchString) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    let regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    let results = regex.exec(searchString);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

function getVidFromLocationBar() {
    return getParameterByName('vid', window.location.search) || getParameterByName('vid', window.location.hash);
}

function getFulldisplayVidParameterFromURL() {
    const pathSegments = window.location.pathname.split('/');
    const vid = pathSegments[pathSegments.length - 1];
    console.log('Extracted vid:', vid);
    return vid;
}

function getCanonicalFullDisplayUrl() {
    if (window.location.href.indexOf('/fulldisplay')<0) {
        return;
    }
    if (window.location.href.indexOf('docid=')<0 || window.location.href.indexOf('vid=')<0) { //possible of Canonical link
       return window.location.href.split('?')[0];
    }
    let docid: string = window.location.href.split('docid=')[1].split('&')[0];
    let vid: string = window.location.href.split('vid=')[1].split('&')[0];
    return window.location.origin + window.location.pathname + '/' + docid  + '/' + vid;
}






// WEBPACK FOOTER //
// ./src/main/webapp/components/bootstrap_app.ts